import * as React from 'react';
import styled from 'styled-components';

const Badges = () => (
    <>
        <StyledBadgeLink
            href="https://itunes.apple.com/us/app/live-auctions/id321243082"
            target="_blank"
            title="Available on the App Store"
        >
            <StyledIosBadge
                alt="mobile"
                height="40"
                loading="lazy"
                src="https://p1.liveauctioneers.com/dist/images/app_store.svg?quality=60"
                width="119.66"
            />
        </StyledBadgeLink>
        <StyledBadgeLink
            href="https://play.google.com/store/apps/details?id=com.liveauctioneers.and"
            target="_blank"
            title="Android App on Google Play"
        >
            <StyledAndroidBadge
                alt="mobile"
                height="40"
                loading="lazy"
                src="https://p1.liveauctioneers.com/dist/images/Google_Play_Store_badge_EN.svg?quality=60"
                width="135.55"
            />
        </StyledBadgeLink>
    </>
);

export default Badges;

const StyledBadgeLink = styled.a`
    height: 40px;
`;

const StyledIosBadge = styled.img`
    max-width: 120px;
    max-height: 40px;
`;

const StyledAndroidBadge = styled.img`
    max-width: 136px;
    max-height: 40px;
    margin-left: 16px;
`;
